'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddresses = getAddresses;
exports.getAddress = getAddress;

var _actions = require('../helpers/actions');

function getAddresses() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'FETCH_LOOKUP_' + data.prefix + '_ADDRESSES',
    promise: function promise(_ref) {
      var api = _ref.api;
      return (0, _actions.handleErrors)(api('/postcode/addresses').get(data));
    }
  };
}

function getAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'FETCH_LOOKUP_' + data.prefix + '_ADDRESS',
    promise: function promise(_ref2) {
      var api = _ref2.api;
      return (0, _actions.handleErrors)(api('/postcode/address').get(data));
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/address.js
// module id = 2426
// module chunks = 0